import React, { useRef } from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  TableAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { v4 as uuidv4 } from "uuid";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const H1BDocuments = () => {
  const containerRef = useRef(null);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        documentType: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        dateOfBirth: { type: "datepicker", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );
  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  const {
    data: documentTypesOptions,
    searchValue: documentTypesSearch,
    handleSearch: handleDocumentTypesSearch,
    resetSearch: resetDocumentTypesSearch,
    handleScroll: handleDocumentTypesScroll,
  } = useDropdownData("documentTypes");

  const tableData = [
    {
      documentType: "I-200-2412-019530",
      title: "Tektree",
      modifiedBy: "Vikranth Desireddy",
      modifiedOn: "2024-12-30T00:00:00.000Z",
      documents: "TEK TREE_H1B APPROVAL_SNEHA KOTAGIRI.pdf",
    },
  ];
  const columns = [
    {
      key: "documentType",
      label: "Document Type",
    },
    {
      key: "title",
      label: "Title",
    },
    {
      key: "modifiedBy",
      label: "Modified By",
    },

    {
      key: "modifiedOn",
      label: "Modified On",
      render: (row) => dateFormator(row.modifiedOn, "month-day-year"),
    },

    {
      key: "documents",
      label: "Documents",
      render: (row) => (
        <div className="text-info cursor-pointer">{row.documents}</div>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  return (
    <div>
      <div className="my-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PERSONAL DETAILS"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Download All Documents"
                size="sm"
                icon={"download"}
                iconPosition={"before"}
              />
              <Button title="Edit" size="sm" />
            </>
          }
        />
        <Divider />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {/* <FormFieldSet
          type="documentTypes"
          title={"Document Type"}
          placeholder="Select Document Type"
          value={formData.documentType}
          onChange={(value) => handleChange("documentType", value)}
          error={errors.documentType}
          required
        /> */}
        <FormFieldSet
          type="select"
          title="Document Type"
          placeholder="Select Document Type"
          keyname={"documentTypes"}
          options={documentTypesOptions}
          value={formData.documentType}
          onChange={(value) => handleChange("documentType", value)}
          error={errors.documentType}
          showSearch
          searchValue={documentTypesSearch}
          onSearch={handleDocumentTypesSearch}
          onClose={resetDocumentTypesSearch}
          showButton
          alertName={"addDocumentType"}
          icon={"add"}
          handleScroll={() => handleDocumentTypesScroll(containerRef)}
          refData={containerRef}
          required
        />
      </div>
      <p className="mt-6">document</p>
      <div className="">
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
        />
      </div>
      <div className="mt-6">
        <PageHeader
          RightSection={
            <>
              <Button title="Cancel" size="sm" variant="outlined" />
              <Button title="Upload" size="sm" />
            </>
          }
        />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_h1bdocuments`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
    </div>
  );
};

export default H1BDocuments;
